import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import isAuthenticated from "../../services/auth";
import updatePermissions from "../../store/actions/permissions/update";
import setRedirectFunction from "../../store/actions/redirect";
import Loading from "../Loading";

class Page extends Component {
  static propTypes = {
    title: PropTypes.string,
    component: PropTypes.elementType
  };

  componentDidMount() {
    document.title = `HUB CO. | ${this.props.title}`;

    /** Update permissions */
    if (!this.props.permissions.updated && isAuthenticated()) {
      /**
       * Caso a lista de permissões não foi obtida do backend,
       * é disparado uma ação para que a lista seja atualizada.
       */
      this.props.dispatch(updatePermissions());
    }

    this.props.dispatch(
      setRedirectFunction(path => this.props.history.push(path))
    );
  }

  render() {
    const Component = this.props.component;

    /** Permissions loading */
    if (this.props.permissions.loading && isAuthenticated()) {
      return (
        <div>
          <br />
          <br />
          <Loading />
        </div>
      );
    }

    return <Component {...this.props} />;
  }
}
export default withRouter(connect(state => state)(Page));



// WEBPACK FOOTER //
// ./src/components/Page/index.js